
import {
  Component,
  namespace,
  Vue,
  State,
  Watch
} from 'nuxt-property-decorator';
import CloseBtn from './CloseBtn.vue';
import NotesStore from '@/store/notes.store';
import {
  NoteHighlight,
  NoteHighlightRecreation
} from '@/types/highlightContract';
import { Site } from '@/types/pageContract';
import { ITextStartEndObject } from '@/types/highlightServerTypes';
import SidePanelStore from '@/components/ui/side-panel/side-panel.store';
import PdfButton from '@/components/ui/side-panel/notes/PdfButton';

const highlightsModule = namespace('highlights.store');

@Component({
  components: { CloseBtn, PdfButton }
})
export default class DevelopmentMenu extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.site)
  site: Site;

  // @ts-ignore
  @State((state) => state.typo3?.page?.page?.id) // notice : there's also id, and that reflects the query param
  pageId: string;

  @highlightsModule.Action
  addHighlightToPage: ({
    pid: string,
    site: Site,
    highlight: NoteHighlight
  }) => Promise<NoteHighlight>;

  @highlightsModule.Getter
  highlightsForPid: (pid: string) => NoteHighlight[];

  showPageHighlights: boolean = NotesStore.showPageNotesOnly;

  closeSidePanel(): void {
    SidePanelStore.rightPanelIsOpen = false;
  }

  @Watch('showPageHighlights')
  showPageHighlightsChanged(change: boolean) {
    NotesStore.showPageNotesOnly = change;
  }

  async addPageHighlight() {
    console.log('adding page highlight');
    const cid = prompt('Write a CID', '0');
    if (cid) {
      await this.createPageHighlightAndSave(Number(cid));
      location.reload();
    }
  }

  printLatestDevtoolHL() {
    const lastHl = this.highlightsForPid(this.pageId)
      .sort((a, b) =>
        a?.createdTimestamp
          ? b?.createdTimestamp
            ? a.createdTimestamp.getTime() - b.createdTimestamp.getTime()
            : -1
          : -1
      )
      .pop();
    console.log(lastHl);
  }

  async createPageHighlightAndSave(cid: number) {
    const selectedTextStartAndEndObject: ITextStartEndObject = {
      startSelectedText: '',
      endSelectedText: ''
    };

    const recreationData: NoteHighlightRecreation = {
      startCID: cid,
      numberOfSiblingsOnStartNode: 0,
      numberofPrevSiblingsOnCIDStartNode: 0,
      startCtypes: null,
      endCID: cid,
      numberOfSiblingsOnEndNode: 0,
      numberofPrevSiblingsOnCIDEndNode: 0,
      endCTypes: null,
      startSelectionInnerText: '',
      endSelectionInnerText: '',
      mathObject: '',
      selectedTextStartAndEndObject,
      totalSiblingsToCIDs: 0,
      ibkngData: {
        cid,
        isPageNote: cid === 0
      }
    };

    const newHighlight: NoteHighlight = {
      userComment: 'Created by devtools',
      hlcolor: 'hl-red',
      id: null,
      createdTimestamp: null,
      timestampSortKey: null,
      selectedText: '',
      ranges: [],
      recreationData,
      pid: '' + this.pageId
    };

    const { highlight } = await this.addHighlightToPage({
      pid: this.pageId,
      site: this.site,
      highlight: newHighlight
    });
    console.log(`Added highlight.`, highlight);
  }
}
